export default __webpack_public_path__ + "adca3fc7e341abc0fd7ff03575edbe60.png";